import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, tap } from 'rxjs/operators';
import {
	downloadKorrespondenzAction,
	downloadKorrespondenzenArchivAction,
	downloadKorrespondenzenArchivSuccessAction,
	downloadKorrespondenzenMergeAction,
	downloadKorrespondenzenMergeSuccessAction,
	downloadKorrespondenzSuccessAction,
} from './korrespondenz.actions';
import { KorrespondenzService } from './korrespondenz.service';

@Injectable()
export class KorrespondenzEffects {
	constructor(
		private actions: Actions,
		private korrespondenzService: KorrespondenzService
	) {}

	downloadKorrespondenz = createEffect(() =>
		this.actions.pipe(
			ofType(downloadKorrespondenzAction),
			switchMap(({ adressat }) =>
				this.korrespondenzService
					.downloadKorrespondenz(adressat)
					.pipe(map(data => downloadKorrespondenzSuccessAction({ data })))
			)
		)
	);

	saveKorrespondenz = createEffect(
		() =>
			this.actions.pipe(
				ofType(downloadKorrespondenzSuccessAction),
				tap(({ data }) => this.korrespondenzService.saveFile(data, 'korrespondenz.doc'))
			),
		{ dispatch: false }
	);

	downloadKorrespondenzenArchiv = createEffect(() =>
		this.actions.pipe(
			ofType(downloadKorrespondenzenArchivAction),
			switchMap(({ aufgabe }) =>
				this.korrespondenzService
					.downloadKorrespondenzenArchiv(aufgabe)
					.pipe(map(data => downloadKorrespondenzenArchivSuccessAction({ data })))
			)
		)
	);

	saveKorrespondenzenArchiv = createEffect(
		() =>
			this.actions.pipe(
				ofType(downloadKorrespondenzenArchivSuccessAction),
				tap(({ data }) =>
					this.korrespondenzService.saveFile(data.blob, data.name ? data.name : 'korrespondenzen.zip')
				)
			),
		{ dispatch: false }
	);

	downloadKorrespondenzenMerge = createEffect(() =>
		this.actions.pipe(
			ofType(downloadKorrespondenzenMergeAction),
			switchMap(({ aufgabe }) =>
				this.korrespondenzService
					.downloadKorrespondenzenMerge(aufgabe)
					.pipe(map(data => downloadKorrespondenzenMergeSuccessAction({ data })))
			)
		)
	);

	saveKorrespondenzenMerge = createEffect(
		() =>
			this.actions.pipe(
				ofType(downloadKorrespondenzenMergeSuccessAction),
				tap(({ data }) =>
					this.korrespondenzService.saveFile(data.blob, data.name ? data.name : 'korrespondenzen.docx')
				)
			),
		{ dispatch: false }
	);
}
